import { IoCreateOutline } from "react-icons/io5";
import styles from "./styles.module.css";
import { useState } from "react";
import ModalCreateUpdateBook from "../ModalCreateUpdateBook";

export default function BookUpdateButton({ collectionRef, bookData, isVirtual, updateTableData }) {
    const [modal, setModal] = useState(false);

    return (<>
        <button title="Atualizar" onClick={() => { setModal(true) }} className={styles.updateButton}>
            <IoCreateOutline />
        </button>

        {modal && <ModalCreateUpdateBook updateTableData={updateTableData} collectionRef={collectionRef} setModalVisible={() => { setModal() }} update={true} bookId={bookData} isVirtual={isVirtual} />}
    </>

    );
}